<mat-form-field
  appearance="outline"
  class="dropdown"
  [ngClass]="{
    single: !isMultiSelect,
    filled: isFilled,
    required: required,
    hasValue: selected,
    'is-full-width': isFullWidth,
    'is-disabled': isDisabled,
    'is-readonly': isReadonly
  }"
  >
  <mat-select
    [formControl]="entriesCtrl"
    [multiple]="isMultiSelect"
    disableOptionCentering
    panelClass="select-dropdown"
    [placeholder]="label"
    [disabled]="isDisabled"
    [ngClass]="isMultiSelect ? '' : 'single'"
    (selectionChange)="
      eventSelection($event.value); eventSelectionObject(selectedEntries)
    "
    (openedChange)="isOpened = $event"
    [xTentionDummyCypress]="dataCy + '.dropdwon-select'"
    [(value)]="selected"
    >
    @if (hasSearch) {
      <mat-icon
        class="search-icon"
        svgIcon="magnify"
      ></mat-icon>
    }
    @if (hasSearch) {
      <mat-option>
        <ngx-mat-select-search
          [formControl]="entriesFilterCtrl"
          [noEntriesFoundLabel]="noEntriesFoundLabel"
          [placeholderLabel]="placeholderLabel"
          >
        </ngx-mat-select-search>
      </mat-option>
    }
    @if (isMultiSelect) {
      <mat-select-trigger>
        <mat-chip-listbox>
          @for (entry of selectedEntries; track entry) {
            <mat-chip-option
          [xTentionDummyCypress]="
            dataCy + '.option-chip.' + entry?.id?.toLowerCase()
          "
              [removable]="true"
              (removed)="onEntryRemoved(entry.id)"
              >
              <span>{{ entry.name }}</span>
              @if (!isOpened) {
                <mat-icon matChipRemove svgIcon="close"></mat-icon>
              }
              @if (isOpened) {
                <span class="delete-empty"></span>
              }
            </mat-chip-option>
          }
        </mat-chip-listbox>
      </mat-select-trigger>
    }
    @if (isMultiSelect) {
      @for (entry of entries; track entry) {
        <mat-option
        [xTentionDummyCypress]="
          dataCy + '.option-multi-select.' + entry?.id?.toLowerCase()
        "
          [value]="entry.id"
          title="{{ entry.name }}"
          >
          {{ entry.name }}
        </mat-option>
      }
    }
    @if (!isMultiSelect) {
      @for (entry of entries; track entry) {
        <mat-option
        [xTentionDummyCypress]="
          dataCy + '.option-single-select.' + entry?.id?.toLowerCase()
        "
          [value]="entry"
          title="{{ entry.name }}"
          #singleSelect
          >
          {{ entry.name }}
        </mat-option>
      }
    }
  </mat-select>
</mat-form-field>
